import api from '../auth';
const slug = 'api/marka_trosilas/';

const MarkaTrosilaService = () => {
    const getMarkaTrosilas = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getMarkaTrosilasLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getMarkaTrosila = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteMarkaTrosila = (id) => {
        return api
            .delete(slug + `marka_trosila/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createMarkaTrosila = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateMarkaTrosila = (id, data) => {
        return api.put(slug + `marka_trosila/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyMarkaTrosila = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getMarkaTrosilas,
        getMarkaTrosilasLazy,
        getMarkaTrosila,
        deleteMarkaTrosila,
        createMarkaTrosila,
        updateMarkaTrosila,
        getOptions,
        copyMarkaTrosila
    };
};

export default MarkaTrosilaService;
